import React from "react";
import { Modal } from "react-bootstrap";
import { FaChevronCircleDown } from "react-icons/fa";
import LoanTransactions from "./loantransactions";
export const LoanTransactionModal = ({ transactions }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <div className="ms-2">
        <FaChevronCircleDown
          className="cursor-pointer"
          onClick={() => setOpen(true)}
        />
      </div>
      <Modal
        show={open}
        onHide={() => setOpen(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contribution-modal"
        scrollable={true}
      >
        <Modal.Header className="p-4" closeButton>
          <Modal.Title>Transactions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LoanTransactions transactions={transactions} />
        </Modal.Body>
      </Modal>
    </>
  );
};
